// extracted by mini-css-extract-plugin
export default {"container":"MWWJEd8t5uFb3EKu1SbS","mainContent":"bxC9KiuUvQleR6f3lhtS"};